<template>
  <div id="app">
    <router-view class="size"/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
.size{
  width: 100%;
  height: 100%;
}
html,body{
  /* .size; */
  /* overflow: hidden; */
  margin: 0;
  padding: 0;
}
#app {
  .size;
}
.message [class*=tiny-] ul {
  list-style: disc inside !important;
}
.message [class*=tiny-] ol {
  list-style: decimal inside !important;
}
:deep(.tiny-card) {
  overflow: auto;
}
.flex {
  display: flex;
}
.flex-jc-start {
  justify-content: flex-start;
}
.flex-jc-center {
  justify-content: center;
}
.flex-jc-end {
  justify-content: flex-end;
}
.flex-jc-space-between {
  justify-content: space-between;
}
.flex-direction-column {
  flex-direction: column;
}
.flex-ai-center {
  align-items: center;
}

.code-container {
  position: relative;
}

.copy-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background: #F0F0F0;
  border: none;
  padding: 5px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 4px;
  z-index: 1;
}

.copy-button:hover {
  background: #e0e0e0;
}
</style>
